<template>
  <div class="group">
    <div class="group__title">{{ group.title }}</div>
    <section
      v-for="topic in group.topics"
      class="group__topic-wrapper"
      :key="`group-${topic.id}`"
    >
      <Topic
        class="group__topic"
        :isUser="isUser"
        :topicTitle="topic.title"
        :topicLevelsLength="topic.levels.length"
        :topicDuration="getTopicDuration(topic)"
        :topicProgress="getTopicProgress(topic)"
      ></Topic>
      <article class="group__level-wrapper">
        <Level
          v-for="level in topic.levels"
          :key="`level-${level.id}`"
          :level="level"
          :isUser="isUser"
          :userId="userId"
          :courseId="courseId"
          :progress="progress"
          :videos="videos"
        ></Level>
      </article>
    </section>
  </div>
</template>

<script>
import Topic from '@/components/course/content/Topic.vue'
import Level from '@/components/course/content/Level.vue'

export default {
  name: 'Group',
  components: {
    Topic,
    Level,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
    videos: {
      type: Array,
      required: true,
    },
    isUser: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: false,
    },
    progress: {
      type: [Array, Object],
      required: false,
    },
  },
  methods: {
    getTopicProgress(topic) {
      let topicProgress = 0
      if (
        (this.isUser && this.progress && this.progress.videos) ||
        (this.isUser && this.progress.length > 0 && this.progress.videos)
      ) {
        topic.levels.map(level => {
          level.videos.map(video => {
            this.progress.videos.map(watched => {
              if (watched.id === video.id) {
                topicProgress++
              }
            })
          })
        })
      }
      return topicProgress
    },
    getTopicDuration(topic) {
      let hours = 0
      let minutes = 0
      let seconds = 0
      topic.levels.map(level => {
        level.videos.map(video => {
          const splitTime = video.duration.split(':')
          hours += parseInt(splitTime[0])
          minutes += parseInt(splitTime[1])
          seconds += parseInt(splitTime[2])
        })
      })
      if (seconds >= 60) {
        minutes += Math.floor(seconds / 60)
        seconds %= 60
      }
      if (minutes >= 60) {
        hours += Math.floor(minutes / 60)
        minutes %= 60
      }
      return `${hours}hrs ${minutes}min`
    },
  },
}
</script>

<style lang="scss" scoped>
.group {
  &__title {
    font-size: 2rem;
    color: var(--white);
    margin-bottom: 30px;
    font-family: var(--font-bold);
  }
  &__topic-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 100px;
  }
  &__level-wrapper {
    border-left: 1px solid var(--light-gray);
    width: 100%;
    @include tablet {
      width: 75%;
    }
  }
  &__topic-quiz-wrapper {
    margin: 0 0 0 auto;
  }
}
</style>
